export default "__VITE_ASSET__C9Ml1hN2__"